/* StorageAccessPage.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./StorageAccessPage.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useMemo, useRef } from 'react';
import { ExperienceStart } from '@atlassian/experience-tracker';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import { useIntl } from 'react-intl-next';
import { usePerformanceMetrics } from '../performance-metrics/performanceMetricsProvider';
var iframeStyles = null;
export var StorageAccessPage = function StorageAccessPage(_ref) {
  var contentId = _ref.contentId,
    spaceKey = _ref.spaceKey,
    url = _ref.url,
    parentProduct = _ref.parentProduct;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var iframeRef = useRef(null);
  var _usePerformanceMetric = usePerformanceMetrics(),
    cancelIframeLoadMetrics = _usePerformanceMetric.cancelIframeLoadMetrics;
  useEffect(function () {
    cancelIframeLoadMetrics();
  }, [cancelIframeLoadMetrics]);
  var src = useMemo(function () {
    var path = "/wiki/embed/storage-access?parentProduct=".concat(parentProduct, "&locale=").concat(locale);
    var origin = url ? new URL(url).origin : window.location.origin;
    return [origin, path].join('');
  }, [locale, parentProduct, url]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExperienceStart, {
    name: ExperienceNames.STORAGE_ACCESS_PAGE,
    id: "".concat(spaceKey, "-").concat(contentId)
  }), /*#__PURE__*/React.createElement("iframe", {
    "data-testid": "storage-access-page-iframe",
    title: "storage-access-iframe",
    src: src,
    ref: iframeRef,
    className: ax(["_19itglyw _1bsb1osq _4t3i1osq"])
  }));
};